import { useParams, useSearchParams } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { notification } from 'antd';
import { useFetch } from './useFetch';
import { IPurchase } from '../types/purchase';
import { useForm } from './useForm';
import { IPurchaseItemsFormRef } from '../components/purchase-items-form';

export const usePurchase = () => {
    const [formData, setFormData] = useState<IPurchase>();
    const formDataFetch = useFetch();
    const saveFetch = useFetch();
    const { id } = useParams();
    const [form] = useForm();
    const itemForms = useRef<IPurchaseItemsFormRef>();
    const [searchParams] = useSearchParams();

    const newRow = id === 'create';

    const getFormData = async () => {
        if (!newRow) {
            const result = await formDataFetch.request({
                url: `/purchases/${id}`,
                method: 'get',
            });
            if (result.success) {
                setFormData(result.data);
            }
        }
    };

    const save = async (data: IPurchase) => {
        const itemFormsValidated = itemForms.current ? await itemForms.current?.validate() : true;
        if (itemFormsValidated) {
            data.items = itemForms.current?.getItems() || [];
            if (typeof searchParams.get('order_id') === 'string') {
                data.order_id = searchParams.get('order_id');
            }
            const result = await saveFetch.request<IPurchase>({
                url: `/purchases/${newRow ? 'create' : `${id}/update`}`,
                method: 'post',
                data,
            });
            if (result.success) {
                notification.success({
                    message: result.message,
                });
            }
        }
    };

    useEffect(() => {
        getFormData();
    }, [id]);

    useEffect(() => {
        form.setFieldsValue(formData);
    }, [formData]);

    return {
        form,
        formData,
        formDataLoading: formDataFetch.loading,
        save,
        saveLoading: saveFetch.loading,
        itemForms,
    };
};
